<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">3</h2>
<p class="vers"><span>Ich weiß</span> nicht, wie du
singest,<br class="calibre1"/>
mein Meister, ich lausche immer in stillem Staunen.</p>
<p class="vers">Dein Licht der Musik erleuchtet die<br class="calibre1"/>
Welt. Der Lebenshauch deiner Musik<br class="calibre1"/>
läuft von Himmel zu Himmel. Der heilige<br class="calibre1"/>
Strom der Musik durchbricht alle Hindernisse<br class="calibre1"/>
von Stein und stürzet fort.</p>
<p class="vers">Mein Herz ersehnt, deinem Sang sich<br class="calibre1"/>
zu einen und ringt umsonst nach Stimme.<br class="calibre1"/>
Ich wollte sprechen, doch Sprache fügt<br class="calibre1"/>
sich dem Sang nicht, da schrei ich getäuscht<br class="calibre1"/>
auf! O du hast mein Herz gefangen<br class="calibre1"/>
in deines Liedes endlosen Maschen, mein<br class="calibre1"/>
Meister. <a id="page6" title="wedi/cal"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?7ee20014